import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

export const createStudentParent = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/studentParent/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const assignStudentParent = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/studentParent/assign`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getAllTypeLink = async (context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/link/getAllTypeLink`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const updateStudentParent = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/studentParent/update/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const getStudentParentById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/studentParent/getStudentParent/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

export const deleteStudentParent = async (id, context) => {
  const response = await axios.delete(
    apiPaths.baseUrl + `/api/studentParent/delete/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// export s